<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_v"></a><em>I dedicate this book to</em> single <em>mothers.</em></p>
<p class="indent-para"><em>You are the nameless celebrity and seldom glorified superstar. Your fan base is limited to the number of offspring you bore. Your fame is overshadowed by anonymity. You carry the blistering sun on your shoulders in the daytime, and withstand the pressure of its descent on your soul in the night. You endure sleepless nights and dreamless days, sacrificing that which nurtures what you know can become. And though human in your struggle, you pull it off with the grace of eagles and brilliance of all that is regal.</em></p>
<p class="indent-para"><em>I am an eyewitness to your struggle and to your courage.</em></p>
<p class="indent-para"><em>I am in awe of you.</em></p>
<p class="indent-para"><em>I offer you a standing ovation.</em></p>
<p class="indent-para"><em>I applaud you.</em></p>
<p class="indent-para"><em>I am one of you.</em></p>
<p class="indent-para"><em>And I dedicate this book, in its entirety, to you.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e4268ad2